"use client";

import { useEffect } from "react";
import cnBind from "classnames/bind";
import { usePathname, useRouter } from "next/navigation";

import { AdminSideNav } from "@/components/AdminSideNav";
import { PageHeadSync } from "@/components/PageHeadSync/PageHeadSync";
import { useAuth } from "@/shared/auth/AuthContext";
import { userHasStaffRole } from "@/shared/auth/staffAccess";

import type { AdminPageLayoutProps } from "./types";

import styles from "./PageLayout.module.scss";

const cx = cnBind.bind(styles);

export const AdminLayout = ({ children, title }: AdminPageLayoutProps) => {
    const pathname = usePathname() ?? "";
    const router = useRouter();
    const userDetailFullWidth = /^\/admin\/users\/[^/]+$/.test(pathname);
    const deployFullWidth =
        pathname.startsWith("/admin/notifications") ||
        userDetailFullWidth;
    const { isReady, isAuthenticated, user } = useAuth();
    const isStaff = userHasStaffRole(user);

    useEffect(() => {
        if (!isReady) return;
        if (!isAuthenticated) {
            void router.replace("/auth?tab=login");
            return;
        }
        if (!isStaff) {
            void router.replace("/cabinet");
        }
    }, [isReady, isAuthenticated, isStaff, router]);

    if (!isReady) {
        return null;
    }

    if (!isAuthenticated || !isStaff) {
        return (
            <>
                <PageHeadSync
                    title="Проверка доступа | Tezam"
                    description="Админ-панель Tezam"
                    robots="noindex,nofollow,noarchive,nosnippet"
                />
                <div className={`${cx("wrapper", "is-admin", "admin-shell")} admin-shell`}>
                    <main className={cx("main")}>
                        <div className={cx("content", { contentDeployFullWidth: deployFullWidth })}>
                            <p style={{ padding: "24px", color: "#64748b" }}>Перенаправление…</p>
                        </div>
                    </main>
                </div>
            </>
        );
    }

    return (
        <>
            <PageHeadSync
                title={title || "Tezam Admin"}
                description="Админ-панель Tezam"
                robots="noindex,nofollow,noarchive,nosnippet"
            />
            <div className={`${cx("wrapper", "is-admin", "admin-shell")} admin-shell`}>
                <AdminSideNav />
                <main className={cx("main")}>
                    <div className={cx("content", { contentDeployFullWidth: deployFullWidth })}>{children}</div>
                </main>
            </div>
        </>
    );
};
